<script lang="ts">
import BotAvatar from '@/components/avatars/BotAvatar.svelte'
import IdentityAvatar from '@/components/avatars/IdentityAvatar.svelte'
import Tooltip from '@/components/Tooltip.svelte'
import { getAgentById } from '@/modules/agents'
import { getIdentityById } from '@/modules/botIdentities'

type Props = {
	agentId?: string | null
	isBot?: boolean
	isEmailType?: boolean
	botIdentyId?: string
}

let { agentId = '', isBot = false, isEmailType = false, botIdentyId = '' }: Props = $props()

let agent = $derived(getAgentById(agentId ?? ''))
let botIdentity = $derived(getIdentityById(botIdentyId ?? ''))
</script>

<div class="absolute bottom-0 left-0 avatar-element">
	{#if $botIdentity && $botIdentity.avatarUrl}
		<Tooltip content={$botIdentity.name || ''} placement="top" variant="light" isDisabledForTouchDevices={false}>
			<IdentityAvatar size="sm" avatar={$botIdentity.avatarUrl} {isEmailType} isBot />
		</Tooltip>
	{:else if isBot}
		<Tooltip content="Bot" placement="top" variant="light" isDisabledForTouchDevices={false}>
			<BotAvatar />
		</Tooltip>
	{:else if $agent}
		<Tooltip content={$agent.fullname} placement="top" variant="light" isDisabledForTouchDevices={false}>
			<IdentityAvatar size="sm" avatar={$agent.avatar} {isEmailType} />
		</Tooltip>
	{/if}
</div>
